import React, { useState } from 'react';
import Section from './Section';
import { useAccountRows, useQuotedAdd } from './hooks';
import { attachablePlans, addonsForPlan, ownedAddonLine, ownedAddonLineId, ownedAddonBlocker } from '../../lib/cartOwnedAddon';
import { select, addBtn, hint, muted, refusal, retryBtn } from './styles';

// A hosting add-on for a plan the account already has
// (src/lib/cartOwnedAddon.js). Offers what the catalog sells for that kind of
// plan; squish-backend prices it when added and refuses what can't attach.
export default function OwnedAddonSection(props) {
  return (
    <Section title="Add-on for a plan they have">
      <OwnedAddonBody {...props} />
    </Section>
  );
}

function OwnedAddonBody({ accountId, isProspect, isInvoice, hostingAddons, onAdd }) {
  const [plans, retry] = useAccountRows({ accountId, enabled: !isProspect && !isInvoice, pick: attachablePlans });
  const [planDomain, setPlanDomain] = useState('');
  const [sku, setSku] = useState('');
  const { add, busy, error, clearError } = useQuotedAdd({ accountId, prospect: null, onAdd });

  const plan = Array.isArray(plans) ? (plans.find(p => p.domain === planDomain) || plans[0] || null) : null;
  const addons = addonsForPlan(hostingAddons, plan);
  const entry = addons.find(a => a.sku === sku) || addons[0] || null;
  const blocker = ownedAddonBlocker({ isInvoice, isProspect, catalog: hostingAddons, plans, addons });

  return (
    <>
      {Array.isArray(plans) && plans.length > 0 && !isInvoice && (
        <select value={plan?.domain || ''} onChange={e => { setPlanDomain(e.target.value); clearError(); }} style={{ ...select, width: '100%', marginBottom: 6 }}>
          {plans.map(p => (
            <option key={p.domain} value={p.domain}>{p.domain}{p.label ? ` · ${p.label}` : ''}</option>
          ))}
        </select>
      )}
      {!blocker && (
        <div style={{ display: 'flex', gap: 6 }}>
          <select value={entry.sku} onChange={e => { setSku(e.target.value); clearError(); }} style={{ ...select, flex: 1, minWidth: 0 }}>
            {addons.map(a => <option key={a.sku} value={a.sku}>{a.label}{a.priceDisplay ? ` · ${a.priceDisplay}` : ''}</option>)}
          </select>
          <button
            onClick={() => add(ownedAddonLine(plan, entry), ownedAddonLineId(plan.domain, entry.sku))}
            disabled={busy}
            style={{ ...addBtn, opacity: busy ? 0.5 : 1 }}
          >
            {busy ? 'Pricing…' : '+ Add'}
          </button>
        </div>
      )}
      {blocker && (
        <div style={muted}>
          {blocker}
          {plans?.error && <button onClick={retry} style={retryBtn}>Retry</button>}
        </div>
      )}
      {error && <div style={refusal}>⚠ {error}</div>}
      <div style={hint}>Goes on that plan, priced when added. To sell an add-on with a new plan, add both from the catalog.</div>
    </>
  );
}
